

































































































































































































import { RankingActionEnum } from '@empathybroker/tsclient-play/dist/enums/ranking-action.enum';
import { Facet as PlayFacet } from '@empathybroker/tsclient-play/dist/models/facet';
import { FacetValue as PlayFacetValue } from '@empathybroker/tsclient-play/dist/models/facet-value';
import { RankingElement } from '@empathybroker/tsclient-play/dist/models/ranking-element';
import { Facet as SearchFacet, Result } from '@empathybroker/tsclient-search';

import { Component } from 'vue/types/options';
import { mapGetters } from 'vuex';

import { ColorEnum, DeviceEnum, FeatureIdEnum, SearchDataLoadTypeEnum } from '../../enums';

import { CONFIG_CONSTS } from '../../store/config/config.consts';

import Badge from '../badge.component.vue';
import EpbButton from '../button.component.vue';
import CrudForm from '../crud/crud-form.component.vue';
import EnabledField from '../crud/enabled-field.component.vue';
import FacetsList from '../facets-list.component.vue';
import RegularFilterSelector from '../filters/regular-filter-selector.component.vue';
import { UiIconButton, UiRippleInk, UiSwitch, UiTextbox } from '../keen-ui';
import RankingResultOverlay from '../ranking/ranking-result-overlay.component.vue';
import ResultsGrid from '../results-grid.component.vue';
import TransitionHeight from '../transition-height.component.vue';
import AttributesRanking from './attributes-ranking.component.vue';
import FacetsConfiguration from './facets-configuration.component.vue';
import ProductsRanking from './products-ranking.component.vue';

export default {
  name: 'configurations-form',
  props: {
    item: {
      type: Object,
      required: true
    },
    pivots: {
      type: Array,
      required: true
    },
    toolsAvailability: {
      type: Object,
      required: true
    },
    searchData: {
      type: Object,
      required: true
    },
    searchFilters: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      required: true
    },
    loadSearchDataEnabled: Boolean,
    acceptActionDisabled: Boolean,
    errorsFields: Array,
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    CrudForm,
    EnabledField,
    UiTextbox,
    RegularFilterSelector,
    UiIconButton,
    TransitionHeight,
    EpbButton,
    UiSwitch,
    FacetsList,
    Badge,
    UiRippleInk,
    ResultsGrid,
    RankingResultOverlay
  },
  computed: {
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      instanceConfig: CONFIG_CONSTS.getters.currentInstance
    }),
    availableToolIds: function (): FeatureIdEnum[] {
      return Object.entries(this.toolsAvailability)
        .reduce((availableToolIds: FeatureIdEnum[], [toolId, permission]: [FeatureIdEnum, boolean]) => {
          if (permission && !!this.getToolConfigComponent(toolId)) {
            availableToolIds.push(toolId);
          }
          return availableToolIds;
        }, []);
    },
    isFacetsPreviewVisible: function (): boolean {
      return (this.areFacetsConfigured && this.showFacetsPreview);
    },
    areFacetsConfigured: function (): boolean {
      return !!this.item.facets.elements.length;
    },
    facets: function (): SearchFacet[] {
      return this.searchData.facets
        .filter((facet: SearchFacet) => !!this.getItemFacet(facet.id))
        .sort((facet1: SearchFacet, facet2: SearchFacet) => {
          let indexOfItemFacet1 = this.getIndexOfItemFacet(facet1.id);
          if (indexOfItemFacet1 < 0) {
            indexOfItemFacet1 = this.searchData.facets.length;
          }
          let indexOfItemFacet2 = this.getIndexOfItemFacet(facet2.id);
          if (indexOfItemFacet2 < 0) {
            indexOfItemFacet2 = this.searchData.facets.length;
          }
          return (indexOfItemFacet1 - indexOfItemFacet2);
        });
    },
    results: function (): any[] {
      return this.searchData.results.map((result: Result) => {
        const resultRankingConfig = this.item.ranking.products.elements.find((element: RankingElement) =>
          (element.fieldValue === result.id));
        return {
          ...result,
          status: (!!resultRankingConfig ? resultRankingConfig.action : undefined)
        };
      });
    },
    resultsGridItemsPerRow: function (): number {
      if (this.$epb.device <= DeviceEnum.MOBILE) {
        return 1;
      }
      if (this.$epb.device <= DeviceEnum.TABLET) {
        return 2;
      }
      if (!this.settingsSectionCollapsed && this.isFacetsPreviewVisible) {
        return 3;
      }
      return 4;
    }
  },
  data: function () {
    return {
      settingsSectionCollapsed: false,
      expandedToolConfigId: undefined,
      editionStarted: false,
      showFacetsPreview: true,
      ColorEnum,
      RankingActionEnum,
      SearchDataLoadTypeEnum,
      FeatureIdEnum
    };
  },
  methods: {
    getToolIcon: function (toolId: FeatureIdEnum): string {
      return {
        [FeatureIdEnum.FACETS_CONFIG]: 'facets',
        [FeatureIdEnum.ATTRIBUTES_RANKING]: 'attributes',
        [FeatureIdEnum.PRODUCTS_RANKING]: 'rankingactions'
      }[toolId];
    },
    getToolMessages: function (toolId: FeatureIdEnum) {
      return {
        [FeatureIdEnum.FACETS_CONFIG]: this.messages.fields.facets,
        [FeatureIdEnum.ATTRIBUTES_RANKING]: this.messages.fields.attributes,
        [FeatureIdEnum.PRODUCTS_RANKING]: this.messages.fields.products
      }[toolId];
    },
    getToolCount: function (toolId: FeatureIdEnum): number {
      return {
        [FeatureIdEnum.FACETS_CONFIG]: this.item.facets.elements.length,
        [FeatureIdEnum.ATTRIBUTES_RANKING]: this.item.ranking.attributes.elements.length,
        [FeatureIdEnum.PRODUCTS_RANKING]: this.item.ranking.products.elements.length
      }[toolId];
    },
    isToolConfigExpanded: function (toolId: FeatureIdEnum): boolean {
      return (!this.editionStarted || (toolId === this.expandedToolConfigId));
    },
    toggleToolConfigExpanded: function (toolId: FeatureIdEnum): void {
      this.expandedToolConfigId = ((toolId !== this.expandedToolConfigId) ? toolId : undefined);
    },
    getToolConfigComponent: function (toolId: FeatureIdEnum): Component {
      return {
        [FeatureIdEnum.FACETS_CONFIG]: FacetsConfiguration,
        [FeatureIdEnum.ATTRIBUTES_RANKING]: AttributesRanking,
        [FeatureIdEnum.PRODUCTS_RANKING]: ProductsRanking
      }[toolId];
    },
    getToolConfigComponentProps: function (toolId: FeatureIdEnum) {
      return {
        [FeatureIdEnum.FACETS_CONFIG]: {
          configuration: this.item.facets,
          messages: this.messages.fields.facets
        },
        [FeatureIdEnum.ATTRIBUTES_RANKING]: {
          attributes: this.item.ranking.attributes,
          messages: this.messages.fields.attributes
        },
        [FeatureIdEnum.PRODUCTS_RANKING]: {
          products: this.item.ranking.products,
          messages: this.messages.fields.products
        }
      }[toolId];
    },
    onStartEditionClick: function (toolId: FeatureIdEnum): void {
      this.editionStarted = true;
      this.toggleToolConfigExpanded(toolId);
    },
    onResultStatusChange: function (result, status: RankingActionEnum): void {
      const indexOfResultRankingConfig = this.item.ranking.products.elements.findIndex((element: RankingElement) =>
        (element.fieldValue === result.id));
      if (indexOfResultRankingConfig >= 0) {
        this.item.ranking.products.elements.splice(indexOfResultRankingConfig, 1);
      }
      if (!!status) {
        this.item.ranking.products.elements.push({
          fieldName: this.instanceConfig.catalog.resultMappings.id,
          fieldValue: result.id,
          action: status,
          filters: {},
          schedule: {}
        } as RankingElement);
      }
      if (!this.editionStarted) {
        this.toggleToolConfigExpanded(FeatureIdEnum.PRODUCTS_RANKING);
      }
    },
    getIndexOfItemFacet: function (facetId: string): number {
      return this.item.facets.elements.findIndex((itemFacet: PlayFacet) => (itemFacet.id === facetId));
    },
    getFacetName: function (facetId: string): string {
      const facet = this.item.facets.elements.find((itemFacet: PlayFacet) => itemFacet.id === facetId);
      return ((!!facet && facet.prettyName) || facetId);
    },
    isFacetValueActionSelected: function (facetId: string, facetValueId: string, action: RankingActionEnum): boolean {
      const itemFacetValue = this.getItemFacetValue(facetId, facetValueId);
      return (!!itemFacetValue && itemFacetValue.action === action);
    },
    getItemFacetValue(facetId: string, facetValueId: string): PlayFacetValue {
      const itemFacet = this.getItemFacet(facetId);
      if (!!itemFacet && !!itemFacet.values) {
        return itemFacet.values.find((itemFacetValue: PlayFacetValue) => itemFacetValue.id === facetValueId);
      }
    },
    getItemFacet: function (facetId: string): PlayFacet {
      return this.item.facets.elements.find((itemFacet: PlayFacet) => (itemFacet.id === facetId));
    },
    getFacetValueActionColor(facetId: string, facetValueId: string, action: RankingActionEnum): ColorEnum {
      if (this.isFacetValueActionSelected(facetId, facetValueId, action)) {
        return {
          [RankingActionEnum.BOOST]: ColorEnum.GREEN,
          [RankingActionEnum.BURY]: ColorEnum.RED
        }[action];
      } else {
        return ColorEnum.GREY;
      }
    },
    onFacetValueActionClick: function (facetId: string, facetValueId: string, action: RankingActionEnum): void {
      const itemFacetValue = this.getItemFacetValue(facetId, facetValueId);
      const itemFacet = this.getItemFacet(facetId);
      if (!itemFacetValue) {
        if (!itemFacet.values) {
          itemFacet.values = [];
        }
        itemFacet.values.push({
          id: facetValueId,
          action: action
        });
      } else {
        if (itemFacetValue.action === action) {
          itemFacet.values.splice(itemFacet.values.indexOf(itemFacetValue), 1);
        } else {
          itemFacetValue.action = action;
        }
      }
    }
  },
  watch: {
    item: {
      handler: function (item): void {
        if (!this.editionStarted &&
          (!!item.facets.elements.length || !!item.ranking.attributes.elements.length || !!item.ranking.products.elements.length)) {
          this.editionStarted = true;
        }
      },
      deep: true,
      immediate: true
    }
  }
};

